<template>
  <div id="contents">
    <div class="recruit_corona" >
      <div class="recruit_corona_main">
        <div class="title_area">
          <p class="title">コロナ対策</p>
        </div>
        <div @click="close" class="back_btn_icon">
          <img src="../assets/img/common/recruit_2021/close.png" alt="close">
        </div>
        <p class="caption">コロナウイルス感染が拡大し、先行きが見えない時代だからこそ、世の中に真に「面白い」コンテンツを届けたい。そのためには、社員が安心できる環境づくりが大切です。感染対策、在宅勤務の取り組みをご紹介します。</p>
      </div>
      <div class="recruit_corona_list">
        <div class="number_area">
          <p class="number"><img src="../assets/img/common/recruit_2022/corona/01.png" alt="01" width="37"></p>
        </div>
        <div class="c_counter counter_01">
          <p class="title">新入社員のスタートも<br />コロナ対策モードで</p>
          <ul class="list">
            <li><p>4月いっぱいは自宅でオンライン研修。</p></li>
            <li><p>入社式は5月に本社の外にて。フィジカル<br />ディスタンス入社式として実施しました！</p></li>
          </ul>
          <ul class="img_list">
            <li><p><img src="../assets/img/common/recruit_2022/corona/counter_01.png" alt="コロナ対策" width="296" /></p></li>
            <li><p><img src="../assets/img/common/recruit_2022/corona/counter_02.png" alt="コロナ対策" width="296" /></p></li>
          </ul>
        </div>
      </div>
      <div class="recruit_corona_list">
        <div class="number_area">
          <p class="number"><img src="../assets/img/common/recruit_2022/corona/02.png" alt="02" width="37"></p>
        </div>
        <div class="c_counter counter_02">
          <p class="title">オフィスではこんな<br />感染対策を</p>
          <p class="office_main_img"><img src="../assets/img/common/recruit_2022/corona/office_01.png" alt="コロナ対策" width="296" /></p>
          <ul class="list">
            <li><p>スタッフの体調管理を毎日行っています。</p></li>
            <li><p>本社ではフリーアドレス制を採用。仕事場所を自由に選べるので、フィジカルディスタンスが保たれています。会社全体で300枚以上の飛沫防止パネルを設置。</p></li>
            <li><p>出社率を抑え、可能な限り在宅勤務をするよう推奨しています。</p></li>
          </ul>
          <ul class="img_list">
            <li><p><img src="../assets/img/common/recruit_2022/corona/office_02.png" alt="コロナ対策" width="296" /></p></li>
            <li><p><img src="../assets/img/common/recruit_2022/corona/office_03.png" alt="コロナ対策" width="296" /></p></li>
          </ul>
          <div class="c_new_employee">
            <p class="img"><img src="../assets/img/common/recruit_2022/corona/employee_01.png" alt="社内行事もLIVE配信しました。" width="294" /></p>
            <p class="name">伊藤瑶二朗（2020年入社）</p>
          </div>
        </div>
      </div>
      <div class="recruit_corona_list">
        <div class="number_area">
          <p class="number"><img src="../assets/img/common/recruit_2022/corona/03.png" alt="03" width="37"></p>
        </div>
        <div class="c_counter counter_03">
          <p class="title">業務オンライン化への<br />取り組み</p>
          <p class="caption">これまで、番組制作現場では「在宅勤務なんて、できるの？」と誰もが思っていましたが、やればできるんです。</p>
          <ul class="list">
            <li><p>全従業員にスマートフォンを支給。連絡ツールに LINE WORKSを導入し、迅速な社内連絡に活用しています。</p></li>
            <li><p>フリーアドレス制に伴い、ノートPCを配布。会議は原則オンライン化しました。</p></li>
            <li><p>若手の研修もオンライン化（業界トップクリエイターを招いての講演もLIVE配信）。</p></li>
          </ul>
          <ul class="img_list">
            <li><p><img src="../assets/img/common/recruit_2022/corona/online_01.png" alt="コロナ対策" width="296" /></p></li>
            <li><p><img src="../assets/img/common/recruit_2022/corona/online_02.png" alt="コロナ対策" width="296" /></p></li>
          </ul>
          <div class="c_new_employee">
            <p class="img"><img src="../assets/img/common/recruit_2022/corona/employee_02.png" alt="「徹子の部屋」の黒柳さんとの打ち合わせもオンラインで行っています。" width="312" /></p>
            <p class="name">山本翼（2020年入社）</p>
          </div>
        </div>
      </div>
      <div class="recruit_corona_list">
        <div class="number_area">
          <p class="number"><img src="../assets/img/common/recruit_2022/corona/04.png" alt="04" width="38"></p>
        </div>
        <div class="c_counter counter_04">
          <p class="title">「出社しない番組制作」<br />の発想力</p>
          <p class="caption">若林社長の「想定外のことが起こったときが、クリエイティブな仕事をする人にとってチャンスなんだ」という言葉のとおり、制作現場ではさまざまな工夫をして、真に「面白い」コンテンツをカタチにしています。</p>
          <div class="c_imagination imagination_01">
            <div class="desc">
              <p>「じゅん散歩」では、いち早くフェースガードを導入。出演者につけてもらって散歩をするように。散歩のスタイルを変え、リモート取材・ガイドを導入し、スタッフの人数を減らし…と番組づくりも状況に応じて変えています。</p>
            </div>
            <div class="imagination_img_wrap">
              <p class="program_img"><img src="../assets/img/common/recruit_2022/corona/imagination_01.png" alt="じゅん散歩" width="296"></p>
              <div class="director">
                <p><img src="../assets/img/common/recruit_2022/corona/director_01.png" alt="林プロデューサー" width="305"></p>
                <p class="name">林プロデューサー</p>
              </div>
            </div>
          </div>
          <div class="c_imagination imagination_02">
            <div class="desc">
              <p>ローランド公式YouTube「THE ROLAND SHOW」は、ロケ以外をすべて在宅で制作。ナレーション録りでは、マイクをナレーターさん宅に送って収録。編集も配信も各ディレクターが自宅で行っています。</p>
            </div>
            <div class="imagination_img_wrap">
              <p class="program_img"><img src="../assets/img/common/recruit_2022/corona/imagination_02.png" alt="THE ROLAND SHOW" width="296"></p>
              <div class="director">
                <p><img src="../assets/img/common/recruit_2022/corona/director_02.png" alt="宋ディレクター" width="321"></p>
                <p class="name">宋ディレクター</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div><!-- #contents -->
</template>
<script>
export default {
  name: 'recruit_info',
  data() {
    return {
      info_post: null,
      request_id: null,
      loading: false,
      post_list: null,
      error: null,
    }
  },
  props: [
    'info_layout_status',
    'request_tag_id'
  ],
  mounted () {
    const ts = this
    setTimeout(function(){
      ts.$emit('page_fade')
    },ts.$parent.page_load_time)
  },
  methods: {
    close(){
      this.$emit('close_icon');
    }
  },
}
</script>

<style scoped lang="sass">
  @mixin recruit_font($size, $line-height, $letter-spacing)
    font-family: 'Noto Sans JP', sans-serif
    font-weight: 700
    font-size: $size
    line-height: $line-height
    letter-spacing: $letter-spacing

  #contents
    width: 100vw
  .recruit_corona
    padding-bottom: 77px
    &_main
      width: 90.4vw
      margin: calc(36.1vw - 41px) auto 0
      padding-bottom: 20px
      background-color: #fff
      position: relative
      .title_area
        position: absolute
        top: -25px
        left: 21px
      .title
        @include recruit_font(26px, 42px, 0.176em)
        color: #fff
        background: #64BC24
        padding: 0 12px 0 9px
        display: table
      .caption
        @include recruit_font(12px, 1.9em, 0.1em)
        margin: -9px 21px 0 21px
        width: 79.2vw
        display: inline-block
      a
        color: #000
        text-decoration: none
      .back_btn_icon
        position: absolute
        top: -20.9vw
        left: 0vw
        img
          width: 32px
          height: 32px
    &_list
      width: 90.4vw
      margin: 0 auto
      margin-top: 21px
      background-color: #fff
      position: relative
      .number_area
        position: absolute
        top: 32px
        left: -18px
        display: flex
        align-items: center
        background: #64BC24
        height: 46px
      .number
        padding: 0 12px 0 31px
      .c_counter
        position: relative
        padding: 28px 0 28px
        .title
          @include recruit_font(20px, 1.5em, 0.138em)
          margin: 0 0 28px 80px
        .caption
          @include recruit_font(14px, 1.8em, 0.024em)
          margin: 0 0 37px
          padding: 0 30px 0 22px
        .office_main_img
          text-align: center
          margin: 0 0 32px
          padding: 0 21px
          img
            width: 100%
        .list
          padding: 0 21px 0 21px
          li
            position: relative
            margin-bottom: 16px
            &::before
              content: ""
              position: absolute
              width: 16px
              height: 16px
              margin: 3px 0 0
              border-radius: 100%
              background: #64BC24
            &:last-child
              margin-bottom: 0px
            p
              @include recruit_font(12px, 1.9em, 0.14em)
              padding-left: 26px
        .img_list
          margin: 30px 0 0
          li
            margin: 18px 0 0
            padding: 0 21px
            &:first-child
              margin: 0
            p
              text-align: center
              img
                width: 100%
      .counter_02
        .title
          margin: 0 0 23px 80px
        .c_new_employee
          margin: 25px 0 0
          padding: 0 5px 0 29px
          .name
            margin: 10px 10px 0 0
      .counter_03
        .c_new_employee
          margin: 46px 0 0
          padding: 0 15px 0 22px
          .name
            margin: 10px 6px 0 0
      .counter_04
        .caption
          margin: 0 0 30px
      .c_new_employee
        .name
          @include recruit_font(11px, 1em, 0.14em)
          margin: 10px 0 0
          color: #64BC24
          text-align: right
        .img
      .c_imagination
        margin: 36px 0 0
        &:first-child
          margin: 0
        .desc
          position: relative
          margin-bottom: 15px
          padding: 0 24px 0 25px
          &::before
            content: ""
            position: absolute
            width: 16px
            height: 16px
            margin: 3px 0 0
            border-radius: 100%
            background: #64BC24
          p
            @include recruit_font(12px, 1.7em, 0.092em)
            padding-left: 25px
            &:last-child
              margin-bottom: 0px
        .imagination_img_wrap
          p
            text-align: center
          .program_img
            padding: 0 21px
            img
              width: 100%
          .director
            margin: 20px 0 0
            .name
              @include recruit_font(11px, 1em, 0.14em)
              color: #64BC24
              text-align: right
      .imagination_01
        .director
          padding: 0 0 0 14px
          .name
            margin: 7px 19px 0 0
      .imagination_02
        .director
          padding: 0 0 0 4px
          .name
            margin: 7px 28px 0 0






  @media screen and (max-width: 374px)
    #contents
    .recruit_corona
      &_main
        margin: 85px auto 0
        .title_area
          left: 3.8vw
        .title
          @include recruit_font(26px, 42px, 1.5px)
        .caption
        a
        .more
          &_text
          &_arrow
        .back_btn_icon
          top: -78px
          left: 0vw
          img
      &_list
        .c_counter
          .title
            @include recruit_font(16px, 1.5em, 0.138em)
            margin: 3px 0 28px 80px
        .counter_02,.counter_03
          .c_new_employee
            padding: 0 21px
            img
              width: 100%
            .name
              margin: 10px 0 0
        .c_imagination
          .imagination_img_wrap
            .director
              padding: 0 21px
              img
                width: 100%
              .name
                margin: 7px 0 0
</style>



// WEBPACK FOOTER //
// src/components/recruit_corona.vue